import { IBidResponse } from '../../typings/IPrebid'
import { CACHE_URL } from '../constants/video'
import mvFetch from './mvFetch'

interface ICacheRecord {
  uuid: string
}

function wrapURI(uri: string): string {
  return `
    <VAST version="3.0">
      <Ad>
        <Wrapper>
          <AdSystem>prebid.org wrapper</AdSystem>
          <VASTAdTagURI><![CDATA[${uri}]]></VASTAdTagURI>
          <Impression></Impression>
          <Creatives></Creatives>
        </Wrapper>
      </Ad>
    </VAST>
  `
}

function toStorageRequest(bid: IBidResponse): { type: string; value: string } {
  const vastValue = bid.vastXml ? bid.vastXml : wrapURI(bid.vastUrl)

  return {
    type: 'xml',
    value: vastValue
  }
}

async function store(bids: IBidResponse[]): Promise<ICacheRecord[]> {
  try {
    const postBody = JSON.stringify({
      puts: bids.map(toStorageRequest)
    })

    const json = await mvFetch.fetchJson(
      CACHE_URL,
      'POST',
      postBody,
      (request) => {
        request.setRequestHeader('Content-Type', 'application/json')
        request.withCredentials = true
      }
    )

    return [...json.responses]
  } catch (e) {
    return []
  }
}

export default async function addVideoCacheKeys(
  bids: IBidResponse[]
): Promise<IBidResponse[]> {
  if (!bids.length) {
    return []
  }

  const records = await store(bids)

  return records.map((record, idx) => ({
    ...bids[idx],
    videoCacheKey: record.uuid
  }))
}
